import * as React from 'react';

import styles from './message-container.module.css';

type Props = {
    direction?: 'normal' | 'reverse';
    children: React.ReactNode;
};

export function MessageContainer(props: Props) {
    return (
        <div
            className={
                props.direction === 'reverse'
                    ? styles['message-container--reverse']
                    : styles['message-container']
            }
        >
            {props.children}
        </div>
    );
}
